'use strict';

var React = require('react');

const SectionContext = /*#__PURE__*/React.createContext(null);

exports.SectionContext = SectionContext;
